import React from 'react';
import LegalLayout from '../../components/LegalLayout';

const Refund = () => (
  <LegalLayout title="MyBusinessAdPro Refund & Cancellation Policy" lastUpdated="February 2026">
    <p>This policy summarises how cancellations and refunds work. It is a customer-friendly companion to the <a href="/legal/terms">Terms of Service</a> (§4), <a href="/legal/trial-terms">Trial Terms</a> (§6–§7), and <a href="/legal/service-agreement">Service Agreement</a> (§6).</p>

    <h2>1. During your 7-day free trial</h2>
    <ul>
      <li><strong>Cancel any time, no questions asked</strong>, before the Trial End Date (23:59 UK time on day 7).</li>
      <li>You will <strong>not</strong> be charged.</li>
      <li>Your account remains read-only until the Trial End Date, then closes.</li>
    </ul>
    <p><strong>How to cancel:</strong></p>
    <ul>
      <li>Dashboard → Account Settings → "Cancel Trial", <strong>or</strong></li>
      <li>Email <strong><a href="mailto:support@mybusinessadpro.co.uk">support@mybusinessadpro.co.uk</a></strong> with subject <code>Cancel Trial</code> from your registered email.</li>
    </ul>

    <h2>2. After the trial — monthly plans</h2>
    <ul>
      <li>You can cancel at any time through the Stripe customer portal from your dashboard.</li>
      <li>Cancellation takes effect at the <strong>end of the current billing cycle</strong>; you retain access until then.</li>
      <li>Monthly fees already paid are <strong>non-refundable</strong> — this is standard for UK SaaS, and is stated in the Service Agreement §6.</li>
    </ul>

    <h2>3. After the trial — annual plans</h2>
    <ul>
      <li>Cancel any time in the first <strong>30 days</strong> of a new annual term and receive a <strong>pro-rata refund</strong> for the unused portion.</li>
      <li>After day 30, annual fees are <strong>non-refundable</strong>.</li>
      <li>Access continues until the end of the paid period.</li>
    </ul>

    <h2>4. Promotional discounts</h2>
    <ul>
      <li>Promo codes apply <strong>only to the first month's charge</strong> unless stated otherwise in the promo terms.</li>
      <li>Cancelling a discounted subscription does <strong>not</strong> entitle you to a refund of prior discounted months.</li>
    </ul>

    <h2>5. Service suspension due to failed payment</h2>
    <ul>
      <li>If Stripe fails to charge your card, we send up to <strong>3 reminders over 7 days</strong>.</li>
      <li>If still unpaid after 7 days, your account is <strong>suspended</strong> (data is retained for 30 days so you can resolve billing without losing anything).</li>
      <li>No partial refund is due for time the account was suspended.</li>
    </ul>

    <h2>6. Your UK consumer rights</h2>
    <p>Nothing in this policy affects your statutory rights under the <strong>Consumer Rights Act 2015</strong> or the <strong>Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013</strong>.</p>
    <ul>
      <li>Because our service is a <strong>digital service performed immediately on signup</strong> and you expressly request the service to begin during the cancellation period, your right to a 14-day "cooling off" refund is waived once you begin using the platform (per Regulation 37(1)(a)).</li>
      <li>If you have a fault, billing error, or accessibility issue we cannot resolve, you may escalate to an <strong>Alternative Dispute Resolution (ADR)</strong> scheme or to the <strong>Small Claims Court</strong> in your local UK jurisdiction (England &amp; Wales, Scotland, or Northern Ireland).</li>
    </ul>

    <h2>7. Exceptional refunds</h2>
    <p>We may, at our sole discretion, issue goodwill refunds where:</p>
    <ul>
      <li>A material service outage prevented use for &gt; 24 consecutive hours, OR</li>
      <li>We made a billing error and charged the wrong amount, OR</li>
      <li>Force majeure events prevent performance.</li>
    </ul>

    <h2>8. How to request a refund</h2>
    <p>Email <strong><a href="mailto:billing@mybusinessadpro.co.uk">billing@mybusinessadpro.co.uk</a></strong> with:</p>
    <ul>
      <li>Your business name + registered email</li>
      <li>Invoice number / Stripe charge ID</li>
      <li>Reason for the refund request</li>
    </ul>
    <p>We aim to respond within <strong>5 working days</strong> and, if approved, refunds are credited via Stripe within <strong>5–10 working days</strong>.</p>

    <hr />
    <p><strong>Contact:</strong> <a href="mailto:billing@mybusinessadpro.co.uk">billing@mybusinessadpro.co.uk</a> · <a href="mailto:support@mybusinessadpro.co.uk">support@mybusinessadpro.co.uk</a></p>
  </LegalLayout>
);
export default Refund;
